import { add } from "./base";
class Handler {
    toString(data) {
        return Array.isArray(data) && data.length == 2 && typeof data[0] == "number" && typeof data[1] == "number"
            ? data[0].toString().padStart(2, "0") + data[1].toString().padStart(2, "0")
            : "";
    }
    fromString(value) {
        return typeof value == "string" && value.length == 4
            ? [Number.parseInt(value.slice(0, 2)), Number.parseInt(value.slice(2))]
            : undefined;
    }
    partialFormat = this.format;
    format(unformatted) {
        let result = unformatted;
        if (unformatted.value.length > 0 && !unformatted.is(0, "0", "1"))
            result = result.prepend("0");
        if (result.value.length > 1)
            result = result.insert(2, " / ");
        return {
            ...result,
            type: "text",
            inputmode: "numeric",
            autocomplete: "cc-exp",
            length: [7, 7],
            pattern: /^(0[1-9]|1[012]) \/ \d\d$/,
        };
    }
    unformat(formatted) {
        return formatted.delete(" / ");
    }
    allowed(symbol, state) {
        return state.value.length < 4 && symbol >= "0" && symbol <= "9";
    }
}
add("card-expires", () => new Handler());
//# sourceMappingURL=card-expires.js.map